/**
 * @license
 * Copyright 厦门乾元盛世科技有限公司 All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file.
 */


import { Component, Input, ElementRef, Renderer, ViewEncapsulation, OnInit, AfterViewInit, Optional, Host } from '@angular/core';
import { Breadcrumb } from './breadcrumb';
/**
 * Breadcrumb 面包屑
 */
export class BreadcrumbItem implements OnInit, AfterViewInit {
/**
 * 样式前缀
 */
prefixCls = 'ant-breadcrumb';
public separator;
/**
 * @param {?} renderer
 * @param {?} elementRef
 * @param {?} breadcrumb
 */
constructor(
private renderer: Renderer,
private elementRef: ElementRef,
private breadcrumb: Breadcrumb) {

    }
/**
 * @return {?}
 */
ngOnInit(): void {
        this.separator = this.breadcrumb.separator;
    }
/**
 * @return {?}
 */
ngAfterViewInit(): void {
        const /** @type {?} */ el: HTMLElement = this.elementRef.nativeElement;
        const /** @type {?} */ link: Node = el.firstChild.firstChild;
        if (link && link instanceof HTMLElement) {
            link.classList.add(`${this.prefixCls}-link`);
        }
    }

static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
    selector: 'ant-breadcrumb-item',
    template: `
        <span><ng-content></ng-content></span>
        <span [class]="prefixCls + '-separator'">{{separator}}</span>
    `,
    styleUrls: ['./style/index.scss'],
    encapsulation: ViewEncapsulation.None
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: Renderer, },
{type: ElementRef, },
{type: Breadcrumb, decorators: [{ type: Optional }, { type: Host }, ]},
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'prefixCls': [{ type: Input },],
};
}

function BreadcrumbItem_tsickle_Closure_declarations() {
/** @type {?} */
BreadcrumbItem.decorators;
/**
 * @nocollapse
 * @type {?}
 */
BreadcrumbItem.ctorParameters;
/** @type {?} */
BreadcrumbItem.propDecorators;
/**
 * 样式前缀
 * @type {?}
 */
BreadcrumbItem.prototype.prefixCls;
/** @type {?} */
BreadcrumbItem.prototype.separator;
/** @type {?} */
BreadcrumbItem.prototype.renderer;
/** @type {?} */
BreadcrumbItem.prototype.elementRef;
/** @type {?} */
BreadcrumbItem.prototype.breadcrumb;
}



interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
